import React, { memo, PropsWithChildren } from 'react';
import { useDropdown } from '../dropdown.context';

export const Trigger = memo(({ children }: PropsWithChildren<unknown>) => {
  const { toggle, triggerRef } = useDropdown();

  return React.cloneElement(children as React.ReactElement, {
    ref: triggerRef,
    onClick: (e: React.MouseEvent) => {
      e.stopPropagation();
      toggle();
      (children as any).props.onClick?.(e);
    },
    'aria-expanded': false,
  });
});

Trigger.displayName = 'Dropdown.Trigger';
